// store/index.ts
import { configureStore } from "@reduxjs/toolkit";
import loginModalReducer from "./features/LoginModal/loginModalSlice";
import investmentModalReducer from "./features/InvestmentModal/investmentModalSlice";
import cartReducer from "./features/AddToCart/cartSlice";
import storeDataReducer from "./features/StoreData/storeData";
import keywordModalSlice from "./features/KeywordModal/keywordSlice";
import helpModalReducer from "./features/HelpModal/helpModalSlice";
import goldInvestModalReducer from "./features/GoldInvestModal/goldInvestModalSlice";
import requestCallbackReducer from "./features/requestCallback/requestCallbackSlice";
import sifDetailsModalSlice from "./features/SIFOverviewModal/sifDetailsModalSlice";
import sifStrategySlice from "./features/SIFStrategyModal/sifStrategySlice";
import ytVideoModalSlice from "./features/ytVideoModal/ytVideoModalSlice";
import videoMPModalSlice from "./features/videoMPModal/videoMPModalSlice";
import jobModalReducer from "./features/jobModal/jobModalSlice";

// A new store per request, so server renders never share state between users.
// isLoggedIn comes from the server (cookies) so SSR and hydration render the same tree.
export const makeStore = (isLoggedIn = false) =>
  configureStore({
    reducer: {
      loginModal: loginModalReducer,
      cart: cartReducer,
      investmentModal: investmentModalReducer,
      storeData: storeDataReducer,
      keywordModal: keywordModalSlice,
      helpModal: helpModalReducer,
      goldInvestModal: goldInvestModalReducer,
      requestCallbackModal: requestCallbackReducer,
      sifStrategyModal: sifStrategySlice,
      sifDetailsModal: sifDetailsModalSlice,
      ytVideoModal: ytVideoModalSlice,
      videoMPModal: videoMPModalSlice,
      jobModal: jobModalReducer,
    },
    preloadedState: {
      loginModal: { isOpen: false, isLoggedIn, modalKey: undefined },
    },
  });

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore["getState"]>;
export type AppDispatch = AppStore["dispatch"];
